import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=2a5fb106"
import script from "./Whatsapp.vue?vue&type=script&lang=ts"
export * from "./Whatsapp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports